import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { apiHolder as api, apis, inWindow, StorageKey, addAccountPageEmailsKey, globalStoreConfig, } from 'api';
import { AutoComplete, Button, Checkbox, Input } from 'antd';
import classnames from 'classnames';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import styles from './index.module.scss';
import CapLockSVG from '@web-common/components/UI/Icons/svgs/CapLock';
import { actions as LoginActions } from '@web-common/state/reducer/loginReducer';
import './index.scss';
import { useActions, useAppSelector } from '@web-common/state/createStore';
import SiriusRadio from '@web-common/components/UI/SiriusRadio';
import ErrorIcon from '@web-common/components/UI/Icons/svgs/ErrorSvg';
import MobileValidate from './validate/mobile';
import QrcodeValidate from './validate/qrcode';
import { doLoginPageViewDataTrack, doLoginPageClickDataTrack } from './dataTracker';
import CorpVerfiyCode from './components/corp-verify-code';
import HostChange from './components/host-change';
import QRCodeSwitch from './components/qrcode-switch';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { emailPattern, ProductProtocols } from '@web-common/utils/constant';
import MobileBindModal from './modal/edmBindMobile';
import { getIn18Text } from 'api';
import LangMenus from '@/layouts/Main/langMenus';
import { jumpToRedirectUrl, safeDecodeURIComponent } from '@web-common/utils/utils';
import useRisk from '@web-common/hooks/useRisk';
import SelfUnBlockMobildModal from './self-unblocking/mobile-modal';
import EmailUnBlockModal from './self-unblocking/email-modal';
import DeviceReportLoginModal from './device-report/device-report-modal';
import VefifyCode from './components/verify-code';
import FeedbackModal from '@/components/Electron/FeedBack/feedbackModal';
import { safeFilteredUrl } from './util';
const changeHashUrl = /^#\/?((?:doc)|(?:sheet)|(?:share)|(?:unitable))/i;
const loginApi = api.api.requireLogicalApi(apis.loginApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const performanceApi = api.api.requireLogicalApi(apis.performanceImpl);
const systemApi = api.api.getSystemApi();
const eventApi = api.api.getEventApi();
const storeApi = api.api.getDataStoreApi();
const inElectron = systemApi.isElectron();
const isWebFf = systemApi.isWebFfEntry();
const resendCodeWaitSpan = 60;
const searchEmailStr = (() => {
    if (!inWindow()) {
        return '';
    }
    try {
        let urlInfo = new URL(document.location.href);
        let searchParams = urlInfo.searchParams;
        return searchParams.get('login-email') || '';
    }
    catch (ex) {
        console.error(ex);
        return '';
    }
})();
const getCurrentEmailList = () => {
    if (!inWindow() || !localStorage) {
        return [];
    }
    try {
        const data = storeApi.getSync(addAccountPageEmailsKey, globalStoreConfig);
        if (data && data.data) {
            return JSON.parse(data.data);
        }
        return [];
    }
    catch (ex) {
        console.error(ex);
        return [];
    }
};
const LAST_LOGIN_TYPE_KEY = 'last-login-type';
const lastLoginTypeStoreConfig = { noneUserRelated: true };
const Login = props => {
    const { registerInfo } = useAppSelector(state => state.loginReducer);
    const { setRegisterInfo } = useActions(LoginActions);
    const { type, initAccount, originLoginKey: loginInfoKey, noBorder, handlerResetPassword, hideQrCodeLogin, onAfterLogout, onBeforeLogin, onAddAccountLoginSuccess, onAfterLogin, onUnLockAppSuccess, shouldShowBack = false, onBackClicked, backStyle = {}, showDeviceReportVisible, setOutDeviceReportVisible, } = props;
    const valRef = React.useRef(null);
    const inputRef = React.useRef(null);
    const [isValidate, setValidate] = useState(false);
    const [validateWay, setValidateWay] = useState('mobile');
    const { doSetLoginInfo } = useActions(LoginActions);
    const { riskManage } = useRisk();
    const [corpMailNeedImgVerifyCode, setCorpMailNeedImgVerifyCode] = useState(false);
    const [isCorpMail, setIsCorpMail] = useState(false);
    const [corpImgVerifyCode, setCorpImgVerifyCode] = useState('');
    const [corpPreloginSid, setCorpPreLoginSid] = useState('');
    const [accountInfo, setAccountInfo] = useState(null);
    const corpVerifyImgCodeInstanceRef = useRef(null);
    const [mobileUnBlockVisible, setMobileUnBlockVisible] = useState(false);
    const [unBlockMobile, setUnBlockMobile] = useState('');
    const [emailUnBlockVisible, setEmailUnBlockVisible] = useState(false);
    const [loginCodeVisible, setLoginCodeVisible] = useState(false);
    const [deviceReportModalVisible, setDeviceReportModalVisible] = useState(false);
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    useEffect(() => {
        if (showDeviceReportVisible) {
            setDeviceReportModalVisible(true);
        }
        else {
            setDeviceReportModalVisible(false);
        }
    }, [showDeviceReportVisible]);
    const { history } = global;
    let _email;
    if (history) {
        _email = history.state ? history.state.email : initAccount || '';
    }
    const isAddAccountPage = type === 'addAccountPage';
    if (isAddAccountPage) {
        _email = searchEmailStr || '';
    }
    const [email, setEmail] = useState(_email);
    const [defaultEmail] = useState(_email);
    const [password, setPwd] = useState('');
    const isUnLockApp = type === 'unlockApp';
    const [protocolChecked, setProtocolChecked] = useState(isWebFf || isUnLockApp);
    const [warning, setWarning] = useState('');
    const [ok, setOk] = useState('');
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [needPersist, setNeedPersist] = useState(true);
    const [autoLogin, setAutoLogin] = useState(!!loginInfoKey);
    const [time, setTime] = useState(resendCodeWaitSpan);
    const [capsLock, setCapsLock] = useState(false);
    const isAddAccount = type === 'addAccount' || type === 'addAccountPage' || type === 'addAccountModal';
    const [currentTab, setCurrentTab] = useState(isWebFf || isUnLockApp ? 'mail' : isAddAccount ? 'mail' : 'mobile');
    const pageSource = isAddAccount ? getIn18Text('YUANSHIQIDONGDENG') : getIn18Text('ZHANGHAOGUANLI-');
    const [mobile, setMobile] = useState('');
    const [eauthEmail, setEauthEmail] = useState('');
    const [certCode, setCertCode] = useState('');
    const [code, setCode] = useState('');
    const [emailCode, setEmailCode] = useState('');
    const [isSendingPhoneCode, setIsSendingPhoneCode] = useState(false);
    const [isSendingEmailCode, setIsSendingEmailCode] = useState(false);
    const [isLoginingWithCode, setIsLoginingWithCode] = useState(false);
    const [isLoginingWithCertCode, setIsLoginingWithCertCode] = useState(false);
    const [isLoginingWithEmailCode, setIsLoginingWithEmailCode] = useState(false);
    const [verifyImgErrorCount, setVerifyImgErrorCount] = useState(0);
    const [visibleBindMobileModal, setVisibleBindMobileModal] = useState(false);
    const [navListenId, setNavListenId] = useState();
    const [originReq, setOriginReq] = useState(null);
    const originReqRef = useRef(originReq);
    originReqRef.current = originReq;
    const mainTitle = useMemo(() => {
        if (isValidate) {
            if (validateWay === 'mobile')
                return getIn18Text('SHOUJIDUANXINYAN');
            if (validateWay === 'mail')
                return getIn18Text('ANQUANYOUXIANGYANZ');
            if (validateWay === 'cert')
                return '请输入手机号收到的验证码';
        }
        return getIn18Text(isWebFf ? 'DENGLUYUNJIAHOUTAI' : isUnLockApp ? 'LOCK_LOGIN_MODAL_TITLE' : process.env.BUILD_ISEDM ? 'DENGLUWANGYIWAIMAO' : 'DENGLUWANGYILING');
    }, [isValidate, validateWay]);
    const openPromptPage = () => {
        trackApi.track('pcLogin_click_free');
        setRegisterInfo({
            isValidate: false,
            mobile: '',
            code: '',
            visible: true,
        });
    };
    const openForgetPwdUrl = () => {
        trackApi.track('pcLogin_click_forget_password');
        loginApi.doOpenForgetPwdUrl(isCorpMail, email && email.trim ? email.trim() : '');
    };
    const [imgVerifyCode, setImgVerifyCode] = useState('');
    const verifyCodeInstanceRef = useRef(null);
    const handleLoginVerifyCodeChanged = (val) => {
        if (!val || !val.length || !val.trim()) {
            setImgVerifyCode('');
        }
        else {
            const trimedVal = val.trim();
            setImgVerifyCode(trimedVal);
        }
    };
    const refresgLoginVerifyCode = () => {
        if (verifyCodeInstanceRef && verifyCodeInstanceRef.current) {
            verifyCodeInstanceRef.current.refreshVerifyImgCode();
        }
    };
    const [verifyLoginImgErrorCount, setVerifyLoginImgErrorCount] = useState(0);
    const handleLoginVerifyCodeLoadError = () => {
        let newErrorCount = verifyLoginImgErrorCount + 1;
        if (newErrorCount > 4) {
            newErrorCount = 0;
        }
        else {
            refresgLoginVerifyCode();
        }
        setVerifyLoginImgErrorCount(newErrorCount);
    };
    const refreshImgVerifyCode = () => {
        const currentRef = corpVerifyImgCodeInstanceRef.current;
        if (currentRef) {
            currentRef.refreshVerifyImgCode();
        }
    };
    const handleVerifyCodeChanged = (val) => {
        if (!val || !val.length || !val.trim()) {
            setCorpImgVerifyCode('');
        }
        else {
            const trimedVal = val.trim();
            setCorpImgVerifyCode(trimedVal);
        }
    };
    const handleVerifyCodeLoadError = () => {
        let newErrorCount = verifyImgErrorCount + 1;
        if (newErrorCount > 4) {
            newErrorCount = 0;
        }
        else {
            refreshImgVerifyCode();
        }
        setVerifyImgErrorCount(newErrorCount);
    };
    useEffect(() => {
        if (corpPreloginSid) {
            refreshImgVerifyCode();
        }
    }, [corpPreloginSid]);
    const handleMouseMove = (e) => {
        if (e.getModifierState) {
            setCapsLock(e.getModifierState('CapsLock'));
        }
    };
    const handleKeyDown = (e) => {
        if (e.getModifierState) {
            setCapsLock(e.getModifierState('CapsLock'));
        }
    };
    const handleKeyup = (e) => {
        if (e.getModifierState) {
            setCapsLock(e.getModifierState('CapsLock'));
        }
    };
    const goBack = () => {
        if (onBackClicked) {
            onBackClicked();
            return;
        }
        setOk('');
        setWarning('');
        setCode('');
        setValidate(false);
        loginApi.refreshStatus();
    };
    const routerUrl = () => {
        const search = location.search;
        let url = '/';
        if ((process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG) && /(?:^|\?|&)redirect_url=([^&#]+)/.test(search)) {
            url = safeDecodeURIComponent(RegExp.$1);
        }
        setTimeout(() => {
            jumpToRedirectUrl(url);
        }, 12);
    };
    const loginSucc = (visibleBindPhone) => {
        console.log(`login success ${type}`);
        performanceApi.saveLog().then(() => {
            if (!type || type === 'common') {
                const search = location.search;
                if (/(?:^|\?|&)redirectUrl=([^&#]+)/.test(search)) {
                    const url = safeFilteredUrl(safeDecodeURIComponent(RegExp.$1));
                    if (url) {
                        window.location.href = url;
                        return;
                    }
                }
                const hash = safeDecodeURIComponent(window.location.hash);
                if (hash && changeHashUrl.test(hash)) {
                    let href = hash.slice(1);
                    if (!href.startsWith('/')) {
                        href = `/${href}`;
                    }
                    setTimeout(() => {
                        window.location.assign(href);
                    }, 12);
                    return;
                }
                if (visibleBindPhone) {
                    !isWebFf && setVisibleBindMobileModal(true);
                    return;
                }
                routerUrl();
                return;
            }
            if (isUnLockApp) {
                return;
            }
            if (type === 'addAccountModal' && onAddAccountLoginSuccess) {
                onAddAccountLoginSuccess();
                return;
            }
            eventApi.sendSysEvent({
                eventName: 'accountAdded',
                eventStrData: 'loginSucc',
                eventData: undefined,
                eventSeq: 0,
            });
        });
    };
    const needChangePwd = () => {
        Modal.info({
            title: getIn18Text('WEIBAOZHANGZHANGHU'),
            okText: getIn18Text('XIUGAIMIMA'),
            onCancel: () => {
                loginApi.setPreLoginPassed(false);
            },
            onOk: () => {
                if (isCorpMail) {
                    loginApi.doOpenForgetPwdUrl(isCorpMail, email.trim());
                    return;
                }
                handlerResetPassword(email.trim(), password.trim());
            },
            centered: true,
        });
    };
    const needOpenSecondCheck = () => {
        Modal.info({
            title: `检测到您需要开启二次登录验证${isCorpMail ? getIn18Text('\uFF0CQINGQUWe') : ''}`,
            okText: getIn18Text('QUKAIQI'),
            onOk: () => {
                if (isCorpMail) {
                    return;
                }
                loginApi.doOpenConfigPage();
            },
            content: getIn18Text('JIJIANGTIAOZHUANDAO'),
        });
    };
    const testLoginCurrentAccount = (currentUser) => {
        if (isAddAccountPage) {
            const emailList = getCurrentEmailList();
            if (!emailList || !emailList.length) {
                return false;
            }
            return emailList.some(it => it === email);
        }
        if (currentUser && currentUser.prop && currentUser.prop.accountAlias) {
            const curAlias = currentUser.prop.accountAlias;
            if (curAlias && curAlias.length > 0) {
                for (const it of curAlias) {
                    if (it === email) {
                        return true;
                    }
                }
            }
        }
        return (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) === email;
    };
    const LoginProtocol = (isDialog) => (React.createElement("span", { className: styles.uProtocol, onClick: e => e.stopPropagation() },
        React.createElement("span", null, isDialog ? getIn18Text('QINGXIANTONGYI') : getIn18Text('WOYIYUEDUBING')),
        React.createElement("a", { href: ProductProtocols.agreement, target: "_blank", rel: "noreferrer" }, getIn18Text('FUWUTIAOKUAN')),
        React.createElement("span", null, getIn18Text('HE')),
        React.createElement("a", { href: ProductProtocols.privacy, target: "_blank", rel: "noreferrer" }, getIn18Text('YINSIZHENGCE'))));
    const openProtocolDialog = () => {
        Modal.info({
            title: LoginProtocol(true),
            okText: getIn18Text('ZHIDAOLE'),
            centered: true,
        });
    };
    const getInputEmptyErrorMsg = (propName) => {
        if (!propName || !propName.length)
            return '';
        return `请输入${propName}`;
    };
    const getIsEmptyString = (str) => {
        if (!str || !str.length || !str.trim()) {
            return true;
        }
        return false;
    };
    const handlePreLoginResponse = (res, needShowWarning = false) => {
        if (!res)
            return;
        if (typeof res === 'object') {
            if (res.err && res.verify_code) {
                if (!loginCodeVisible) {
                    setLoginCodeVisible(true);
                    setWarning('');
                    return;
                }
                else {
                    refresgLoginVerifyCode();
                }
            }
            if (res.errmsg && res.errmsg.length) {
                needShowWarning && setWarning(res.errmsg);
                return;
            }
            const _isCorpMail = res.isCorpMailMode;
            setIsCorpMail(res.isCorpMailMode);
            if (_isCorpMail) {
                setCorpMailNeedImgVerifyCode(Boolean(res.verify_code));
                setCorpPreLoginSid(res.sid);
            }
            else {
                setCorpMailNeedImgVerifyCode(false);
                setCorpPreLoginSid('');
            }
        }
        else {
            needShowWarning && setWarning(res);
        }
    };
    const onFocusInput = () => {
        setOk('');
        setWarning('');
    };
    const setEmailAccount = () => {
        const _accountInfo = systemApi.handleAccountAndDomain(email);
        if (!_accountInfo || !_accountInfo.account || !_accountInfo.domain) {
            setAccountInfo(null);
        }
        else {
            setAccountInfo(_accountInfo);
        }
    };
    const doPreLogin = (mail, needShowWarning = false) => {
        loginApi
            .doPreLogin(mail.trim())
            .then(res => {
            handlePreLoginResponse(res, needShowWarning);
        })
            .catch(err => {
            console.log('doPrelogin error', err);
        });
    };
    const onPreLogin = () => {
        if (email) {
            const pattern = emailPattern;
            if (pattern.test(email)) {
                doPreLogin(email, false);
            }
            else {
                setWarning(getIn18Text('YOUXIANGZHANGHAOGE'));
            }
        }
    };
    const onEmailInputBlur = () => {
        if (currentTab === 'mail') {
            onPreLogin();
            setEmailAccount();
        }
    };
    function startCountDown() {
        setTime(prev => {
            setTimeout(() => {
                if (prev > 0) {
                    if (prev > 5) {
                        setOk('');
                    }
                    startCountDown();
                }
                else {
                    setTime(resendCodeWaitSpan);
                }
            }, 1000);
            return prev > 0 ? prev - 1 : 0;
        });
    }
    const onGetCode = () => {
        setWarning('');
        if (isSendingPhoneCode)
            return;
        setIsSendingPhoneCode(true);
        loginApi
            .doSendVerifyCode()
            .then(r => {
            console.log(r);
            if (r) {
                setWarning(r);
            }
            else {
                startCountDown();
            }
        })
            .catch(err => {
            console.error('onGetCode error', err);
        })
            .finally(() => {
            setIsSendingPhoneCode(false);
        });
    };
    const onGetEmailCode = () => {
        setWarning('');
        if (isSendingEmailCode)
            return;
        setIsSendingEmailCode(true);
        const emailArr = email.trim().split('@');
        if (!emailArr[0] || !emailArr[1])
            return;
        loginApi
            .doSendVerifyMail()
            .then(r => {
            console.log(r);
            if (r) {
                setWarning(r);
            }
            else {
                startCountDown();
            }
        })
            .catch(err => {
            console.error('onGetEmailCode error', err);
        })
            .finally(() => {
            setIsSendingEmailCode(false);
        });
    };
    const onGetCertCode = async () => {
        try {
            setWarning('');
            if (isLoginingWithCertCode)
                return;
            setIsLoginingWithCertCode(true);
            const emailArr = email.trim().split('@');
            if (!emailArr[0] || !emailArr[1])
                return;
            const res = await loginApi.doSendVerifyCert(email);
            if (res.success) {
                startCountDown();
            }
            else {
                setWarning(res.message || '');
            }
        }
        catch (error) {
            console.error('onGetCertCode error', error);
        }
        setIsLoginingWithCertCode(false);
    };
    const onLoginWithCode = () => {
        if (getIsEmptyString(code)) {
            setWarning(getInputEmptyErrorMsg(getIn18Text('YANZHENGMA')));
        }
        else {
            performanceApi.time({ statKey: 'login', statSubKey: 'login_code' }).then();
            setIsLoginingWithCode(true);
            loginApi.doLoginWithCode(code.trim(), (needPersist ? 1 : 0)).then(value => {
                if (value.pass) {
                    performanceApi.timeEnd({ statKey: 'login', statSubKey: 'login_code' }).then();
                    loginSucc();
                    trackApi.track('pcLogin_click_confirm_verificationPage', { pageSource, confirmResult: 'true', currentTab });
                }
                else if (!value.showConfig && value.secondCheck && value.checkType === 'cert') {
                    handleCertSecondCheck(value);
                }
                else if (value.errmsg) {
                    setWarning(value.errmsg);
                    performanceApi.timeEnd({ statKey: 'login', statSubKey: 'login_code' }, true).then();
                    doLoginPageClickDataTrack(pageSource, 'false', value.errmsg);
                    performanceApi.point({ statKey: 'login_ev', statSubKey: 'login_code_failed', value: 1, valueType: 4, flushAndReportImmediate: true }).then();
                    trackApi.track('pcLogin_click_confirm_verificationPage', {
                        pageSource,
                        confirmResult: 'false',
                        checkFalseReason: value.errmsg,
                        currentTab,
                    });
                }
                else if (value.showResetPass) {
                    needChangePwd();
                    performanceApi.timeEnd({ statKey: 'login', statSubKey: 'login_code' }, true).then();
                    performanceApi.point({ statKey: 'login_ev', statSubKey: 'login_code_need_change_pwd', value: 1, valueType: 4 }).then();
                    trackApi.track('pcLogin_click_confirm_verificationPage', {
                        pageSource,
                        confirmResult: 'false',
                        checkFalseReason: getIn18Text('XUGENGHUANMIMA'),
                        currentTab,
                    });
                }
                if (!value.pass) {
                    setIsLoginingWithCode(false);
                }
            });
        }
    };
    const handleCertSecondCheck = (value) => {
        setValidateWay('cert');
        autoGetCode('cert');
        performanceApi.point({ statKey: 'login_ev', statSubKey: 'login_common_need_cert_code', value: 1, valueType: 4 }).then();
    };
    const handleMobileOrMailSecondCheck = (value) => {
        const loginType = currentLoginType === 'QRCodeLogin' ? 'qrcode' : 'email';
        if (value.showConfig) {
            doLoginPageClickDataTrack(pageSource, 'false', getIn18Text('XUKAIQIERCI'), loginType);
            performanceApi.point({ statKey: 'login_ev', statSubKey: 'login_common_need_second_pop', value: 1, valueType: 4 }).then();
            performanceApi.timeEnd({ statKey: 'login', statSubKey: 'login_common' }, true).then();
            needOpenSecondCheck();
            loginApi.refreshStatus();
        }
        else {
            setValidate(true);
            const { checkType } = value;
            if (checkType === 'mobile') {
                setValidateWay('mobile');
                autoGetCode('mobile');
                setMobile(value.mobile || '***********');
                performanceApi.point({ statKey: 'login_ev', statSubKey: 'login_common_need_mobile_code', value: 1, valueType: 4 }).then();
            }
            if (checkType === 'mail') {
                setValidateWay('mail');
                autoGetCode('mail');
                setEauthEmail(value.eauthEmail || '***********');
                performanceApi.point({ statKey: 'login_ev', statSubKey: 'login_common_need_mail_code', value: 1, valueType: 4 }).then();
            }
            trackApi.track('pcLogin_view_verificationPage', { pageSource });
            performanceApi.timeEnd({ statKey: 'login', statSubKey: 'login_common' }, true).then();
            doLoginPageClickDataTrack(pageSource, 'false', getIn18Text('XUERCIYANZHENG'), loginType);
        }
    };
    const onLoginWithEmailCode = () => {
        if (getIsEmptyString(emailCode)) {
            setWarning(getInputEmptyErrorMsg(getIn18Text('YANZHENGMA')));
        }
        else {
            setIsLoginingWithEmailCode(true);
            loginApi.doLoginWithMail(emailCode.trim(), (needPersist ? 1 : 0)).then(value => {
                setIsLoginingWithEmailCode(false);
                if (value.pass) {
                    loginSucc();
                    trackApi.track('pcLogin_click_confirm_verificationPage', { pageSource, confirmResult: 'true', currentTab });
                }
                else if (value.errmsg) {
                    setWarning(value.errmsg);
                    doLoginPageClickDataTrack(pageSource, 'false', value.errmsg);
                    trackApi.track('pcLogin_click_confirm_verificationPage', {
                        pageSource,
                        confirmResult: 'false',
                        checkFalseReason: value.errmsg,
                        currentTab,
                    });
                }
                else if (!value.showConfig && value.secondCheck && value.checkType === 'cert') {
                    handleCertSecondCheck(value);
                }
                else if (value.showResetPass) {
                    needChangePwd();
                    trackApi.track('pcLogin_click_confirm_verificationPage', {
                        pageSource,
                        confirmResult: 'false',
                        checkFalseReason: getIn18Text('XUGENGHUANMIMA'),
                        currentTab,
                    });
                }
                if (!value.pass) {
                    setIsLoginingWithEmailCode(false);
                }
            });
        }
    };
    const onLoginWithCertCode = async () => {
        if (getIsEmptyString(certCode)) {
            setWarning(getInputEmptyErrorMsg(getIn18Text('YANZHENGMA')));
        }
        else {
            setIsLoginingWithCertCode(true);
            const value = await loginApi.doLoginWithCertCode(email, certCode.trim());
            setIsLoginingWithCertCode(false);
            if (value.pass) {
                loginSucc();
                trackApi.track('pcLogin_click_confirm_verificationPage', { pageSource, confirmResult: 'true', currentTab });
            }
            else if (value.errmsg) {
                setWarning(value.errmsg);
                doLoginPageClickDataTrack(pageSource, 'false', value.errmsg);
                trackApi.track('pcLogin_click_confirm_verificationPage', {
                    pageSource,
                    confirmResult: 'false',
                    checkFalseReason: value.errmsg,
                    currentTab,
                });
            }
            else if (value.secondCheck) {
                handleMobileOrMailSecondCheck(value);
            }
            else if (value.showResetPass) {
                needChangePwd();
                trackApi.track('pcLogin_click_confirm_verificationPage', {
                    pageSource,
                    confirmResult: 'false',
                    checkFalseReason: getIn18Text('XUGENGHUANMIMA'),
                    currentTab,
                });
            }
            if (!value.pass) {
                setIsLoginingWithCertCode(false);
            }
        }
    };
    const keyDownHandler = (e, validateWay) => {
        switch (e.key) {
            case 'Enter':
                e.preventDefault();
                if (validateWay === 'mobile')
                    onLoginWithCode();
                if (validateWay === 'mail')
                    onLoginWithCode();
                if (validateWay === 'cert')
                    onLoginWithCertCode();
                break;
            default:
                console.log('press for login');
        }
    };
    const onQrCodeLogin = (value) => {
        handleLoginReturn(value);
    };
    const handleLoginReturn = async (value) => {
        var _a;
        const { checkType } = value;
        setLoading(false);
        setAutoLogin(false);
        const loginType = currentLoginType === 'QRCodeLogin' ? 'qrcode' : 'email';
        if (value.pass) {
            if (isUnLockApp) {
                onUnLockAppSuccess && onUnLockAppSuccess();
                return;
            }
            doLoginPageClickDataTrack(pageSource, 'true', '', loginType);
            performanceApi.timeEnd({ statKey: 'login', statSubKey: 'login_common' }).then();
            const needVisibleBindMobile = needBindMobile(value.mobile || ((_a = value.res) === null || _a === void 0 ? void 0 : _a.mobile));
            loginSucc(needVisibleBindMobile);
            setLoading(isAddAccountPage ? true : false);
        }
        else if (value.errmsg && !value.showDeviceReport) {
            doLoginPageClickDataTrack(pageSource, 'false', value.errmsg, loginType);
            performanceApi.point({ statKey: 'login_ev', statSubKey: 'login_common_failed', value: 1, valueType: 4, flushAndReportImmediate: true }).then();
            performanceApi.timeEnd({ statKey: 'login', statSubKey: 'login_common' }, true).then();
            setLoginCodeVisible(false);
            setWarning(value.errmsg);
        }
        else if (value.secondCheck) {
            if (value.showConfig) {
                doLoginPageClickDataTrack(pageSource, 'false', getIn18Text('XUKAIQIERCI'), loginType);
                performanceApi.point({ statKey: 'login_ev', statSubKey: 'login_common_need_second_pop', value: 1, valueType: 4 }).then();
                performanceApi.timeEnd({ statKey: 'login', statSubKey: 'login_common' }, true).then();
                needOpenSecondCheck();
                loginApi.refreshStatus();
            }
            else {
                setValidate(true);
                if (checkType === 'mobile') {
                    setValidateWay('mobile');
                    autoGetCode('mobile');
                    setMobile(value.mobile || '***********');
                    performanceApi.point({ statKey: 'login_ev', statSubKey: 'login_common_need_mobile_code', value: 1, valueType: 4 }).then();
                }
                if (checkType === 'mail') {
                    setValidateWay('mail');
                    autoGetCode('mail');
                    setEauthEmail(value.eauthEmail || '***********');
                    performanceApi.point({ statKey: 'login_ev', statSubKey: 'login_common_need_mail_code', value: 1, valueType: 4 }).then();
                }
                if (checkType === 'cert') {
                    setValidateWay('cert');
                    autoGetCode('cert');
                    performanceApi.point({ statKey: 'login_ev', statSubKey: 'login_common_need_cert_code', value: 1, valueType: 4 }).then();
                }
                trackApi.track('pcLogin_view_verificationPage', { pageSource });
                performanceApi.timeEnd({ statKey: 'login', statSubKey: 'login_common' }, true).then();
                doLoginPageClickDataTrack(pageSource, 'false', getIn18Text('XUERCIYANZHENG'), loginType);
            }
        }
        else if (value.showResetPass) {
            needChangePwd();
            doLoginPageClickDataTrack(pageSource, 'false', getIn18Text('XUGENGHUANMIMA'), loginType);
            performanceApi.point({ statKey: 'login_ev', statSubKey: 'login_common_need_change_pwd', value: 1, valueType: 4 }).then();
            performanceApi.timeEnd({ statKey: 'login', statSubKey: 'login_common' }, true).then();
        }
        else if (value.spamLock) {
            if (value.spamType === 'auto') {
                setMobileUnBlockVisible(true);
                setUnBlockMobile(value.mobile || '');
            }
            else if (value.spamType === 'apply') {
                setEmailUnBlockVisible(true);
            }
        }
        else if (value.showVerifyCode) {
            setLoginCodeVisible(true);
            setWarning('');
        }
        else if (value.showDeviceReport) {
            setDeviceReportModalVisible(true);
        }
        else if (value.riskVerify) {
            riskManage({ val: value, callback: handleLoginReturn });
        }
        else if (value.showMailMasterDownload) {
            Modal.error({
                content: getIn18Text('UPDATE_TO_MM'),
                maskClosable: false,
                okText: getIn18Text('DOWNLOAD_NOW'),
                onOk: () => {
                    loginApi.doOpenMailMasterDownloadPage();
                },
            });
        }
        if (!value.pass && isCorpMail) {
            const msgErrorCode = value.errCode;
            if (msgErrorCode === 'ERR.SESSIONNULL') {
                doPreLogin(email, false);
            }
            else {
                refreshImgVerifyCode();
            }
        }
    };
    const onLogin = () => {
        performanceApi.time({ statKey: 'login', statSubKey: 'login_common' }).then();
        if (!email && !password) {
            setWarning(getInputEmptyErrorMsg(getIn18Text('YOUXIANGDEZHIHE')));
        }
        else if (!email) {
            setWarning(getInputEmptyErrorMsg(getIn18Text('YOUXIANGDEZHIHE')));
        }
        else if (!password) {
            setWarning(getInputEmptyErrorMsg(getIn18Text('MIMA')));
        }
        else if (!protocolChecked) {
            openProtocolDialog();
        }
        else if (corpMailNeedImgVerifyCode && getIsEmptyString(corpImgVerifyCode)) {
            setWarning(getInputEmptyErrorMsg(getIn18Text('YANZHENGMA')));
        }
        else if (loginCodeVisible && getIsEmptyString(imgVerifyCode)) {
            setWarning(getInputEmptyErrorMsg(getIn18Text('YANZHENGMA')));
        }
        else {
            setLoading(true);
            if (isUnLockApp) {
                const currentUser = systemApi.getCurrentUser();
                if (currentUser) {
                    if ((currentUser.loginAccount && email !== currentUser.id && email !== currentUser.loginAccount) || (!currentUser.loginAccount && email !== currentUser.id)) {
                        setWarning(getIn18Text('UNLOCK_OTRER_ACCOUNT_ERROR'));
                        setLoading(false);
                        return;
                    }
                }
                if (!navigator.onLine) {
                    const loginAccount = email;
                    const pwd = password;
                    loginApi
                        .doCheckPasswordMatch(pwd, loginAccount)
                        .then(isMatch => {
                        if (isMatch) {
                            onUnLockAppSuccess && onUnLockAppSuccess();
                        }
                        else {
                            setWarning(getIn18Text('UNLOCK_AFTER_NETWORK_TIP'));
                        }
                    })
                        .catch(err => {
                        console.error('doCheckPasswordMatch-catch', err);
                        setWarning(getIn18Text('UNLOCK_AFTER_NETWORK_TIP'));
                    })
                        .finally(() => {
                        setLoading(false);
                    });
                    return;
                }
            }
            const currentUser = systemApi.getCurrentUser();
            if (isAddAccount) {
                if (testLoginCurrentAccount(currentUser)) {
                    if (isAddAccountPage) {
                        SiriusMessage.warn({ content: getIn18Text('GAIZHANGHAOYIDENG') });
                    }
                    else {
                        eventApi.sendSysEvent({
                            eventName: 'accountAdded',
                            eventStrData: 'loginCurrentAccount',
                            eventData: undefined,
                            eventSeq: 0,
                        });
                    }
                    setLoading(false);
                    return;
                }
                if (type !== 'addAccountModal') {
                    eventApi.sendSysEvent({
                        eventName: 'accountAdded',
                        eventStrData: 'loginStart',
                        eventData: undefined,
                        eventSeq: 0,
                    });
                }
            }
            doLoginPageClickDataTrack(pageSource, 'false', getIn18Text('DENGLUDIANJI'));
            const noClearActionStore = !!isCorpMail;
            const logoutPromise = isAddAccount && !isAddAccountPage && !isUnLockApp
                ? loginApi.doLogout(true, true, noClearActionStore).then(() => {
                    if (onAfterLogout) {
                        onAfterLogout();
                    }
                    return Promise.resolve();
                })
                : Promise.resolve();
            logoutPromise
                .then(() => loginApi.doPreLogin(email.trim(), false, '', imgVerifyCode))
                .then(res => {
                handlePreLoginResponse(res, true);
                const errMsg = typeof res === 'object' ? res.errmsg : '';
                return !errMsg;
            })
                .then((flag) => {
                if (flag) {
                    if (onBeforeLogin) {
                        onBeforeLogin();
                    }
                    return loginApi.doLogin({
                        account: email.trim(),
                        pwd: password.trim(),
                        verifyCode: isCorpMail ? corpImgVerifyCode : imgVerifyCode,
                        isUnLockApp: isUnLockApp,
                    });
                }
                else {
                    setLoading(false);
                }
                throw Error('prelogin failed');
            })
                .then(value => {
                if (onAfterLogin) {
                    onAfterLogin(value);
                }
                handleLoginReturn(value);
            })
                .catch(ex => {
                if (onAfterLogin) {
                    onAfterLogin();
                }
                setLoading(false);
                console.error('login error', ex);
            })
                .finally(() => {
                doSetLoginInfo({ loginAccount: email, loginId: password, nickName: '' });
            });
        }
    };
    useEffect(() => {
        doLoginPageViewDataTrack(pageSource);
        if (initAccount) {
            setEmail(initAccount);
        }
    }, []);
    useEffect(() => {
        if (isUnLockApp) {
            return;
        }
        if (type !== 'addAccount' && type !== 'addAccountModal') {
            const { suc, data } = storeApi.getSync('loginCurrentTab', { noneUserRelated: true });
            if (suc && data) {
                setCurrentTab(data);
            }
        }
    }, []);
    useEffect(() => {
        if (isUnLockApp)
            return;
        const currentUser = systemApi.getCurrentUser();
        if (currentUser && currentUser.id && !isAddAccount && !systemApi.isBkLoginInit()) {
            trackApi.track('pc_login_page_has_account_already_sign_in', { currentUser });
            console.warn('[login] auto login triggered', currentUser);
            loginApi.doTryLoginWithCurrentState(currentUser.id, currentUser.sessionId).then((re) => {
                if (re.pass) {
                    console.warn('[login] auto login triggered success', currentUser, re);
                    loginSucc();
                }
            });
        }
    }, []);
    useEffect(() => {
        var _a;
        if (currentTab === 'mail') {
            accountApi.doGetAccountList().then(({ localList }) => {
                if (localList.length) {
                    const list = localList.map(item => ({
                        value: item.id,
                    }));
                    setOptions(list);
                }
            });
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus({
                cursor: 'end',
            });
        }
    }, [currentTab]);
    const autoGetCode = (way) => {
        valRef.current.focus({
            cursor: 'start',
        });
        if (way === 'mobile')
            onGetCode();
        if (way === 'mail')
            onGetEmailCode();
        if (way === 'cert')
            onGetCertCode();
    };
    useEffect(() => {
        console.log('[login-tsx] loginInfoKey', loginInfoKey);
        if (loginInfoKey && loginInfoKey.length > 0) {
            eventApi.sendSysEvent({
                eventName: 'loginBlock',
                eventData: true,
            });
            setOk(getIn18Text('ZHENGZAIZIDONGDENG'));
            setAutoLogin(true);
            setLoading(true);
            loginApi
                .doLoadDataAndAutoLogin(loginInfoKey)
                .then((res) => {
                handleLoginReturn(res);
            })
                .catch(reason => {
                setWarning(reason);
                setAutoLogin(false);
            })
                .finally(() => {
                setLoading(false);
            });
        }
    }, [loginInfoKey]);
    useEffect(() => {
        if (document && document.addEventListener) {
            document.addEventListener('keyup', handleKeyup, false);
            document.addEventListener('keydown', handleKeyDown, false);
            document.addEventListener('mousemove', handleMouseMove, false);
            return () => {
                window.removeEventListener('keyup', handleKeyup, false);
                window.removeEventListener('keydown', handleKeyDown, false);
                window.removeEventListener('mousemove', handleMouseMove, false);
            };
        }
        return () => { };
    }, []);
    const msgValidateDiv = (React.createElement("div", { className: styles.msgValidateWrap },
        React.createElement("div", { className: styles.uPhone },
            getIn18Text('YANZHENGMAYITONG'),
            React.createElement("span", { className: "blue" }, mobile)),
        React.createElement("div", { className: classnames(styles.uInput, styles.uCode) },
            React.createElement(Input, { allowClear: true, "data-test-id": "mobile-code-input", maxLength: isCorpMail ? 10 : 6, placeholder: `请输入${isCorpMail ? '' : 6}位验证码`, value: code, onFocus: onFocusInput, onChange: e => {
                    setCode(e.target.value);
                }, onKeyDown: e => keyDownHandler(e, 'mobile'), ref: valRef }),
            React.createElement("div", { className: styles.uCodeText }, time < resendCodeWaitSpan ? (`${time}s后重试`) : (React.createElement("span", { className: "blue", onClick: onGetCode }, getIn18Text('HUOQUYANZHENGMA'))))),
        React.createElement("div", { style: { width: '100%' } },
            React.createElement(Button, { type: "primary", "data-test-id": "mobile-code-login-btn", className: styles.uPrimaryBtn, onClick: onLoginWithCode, block: true, loading: isLoginingWithCode }, getIn18Text('QUEDING')))));
    const mailValidateDiv = (React.createElement("div", { className: styles.msgValidateWrap },
        React.createElement("div", { className: styles.uPhone },
            getIn18Text('YANZHENGMAYITONGGYJFSZ'),
            React.createElement("span", { className: "blue" }, eauthEmail)),
        React.createElement("div", { className: classnames(styles.uInput, styles.uCode) },
            React.createElement(Input, { allowClear: true, "data-test-id": "mobile-code-input", maxLength: isCorpMail ? 10 : 6, placeholder: `请输入${isCorpMail ? '' : 6}位验证码`, value: emailCode, onFocus: onFocusInput, onChange: e => {
                    setEmailCode(e.target.value);
                }, onKeyDown: e => keyDownHandler(e, 'mail'), ref: valRef }),
            React.createElement("div", { className: styles.uCodeText }, time < resendCodeWaitSpan ? (`${time}s后重试`) : (React.createElement("span", { className: "blue", onClick: onGetEmailCode }, getIn18Text('HUOQUYANZHENGMA'))))),
        React.createElement("div", { style: { width: '100%' } },
            React.createElement(Button, { type: "primary", "data-test-id": "mobile-code-login-btn", className: styles.uPrimaryBtn, onClick: onLoginWithEmailCode, block: true, loading: isLoginingWithEmailCode }, getIn18Text('QUEDING')))));
    const loginFormDiv = (React.createElement("div", null,
        React.createElement("div", { className: styles.uInput },
            React.createElement(AutoComplete, { style: { width: '100%' }, options: options, key: "auto", value: email, maxLength: 128, defaultValue: defaultEmail, dropdownClassName: "sirusDrop", filterOption: (inputValue, option) => option.value.toUpperCase().indexOf(inputValue.toUpperCase()) === 0, onChange: value => {
                    setEmail(value);
                } },
                React.createElement(Input, { spellCheck: "false", "data-test-id": "account", placeholder: getIn18Text('WANGYIQIYEYOU'), value: email, ref: inputRef, onChange: e => {
                        setEmail(e.target.value);
                    }, onBlur: onEmailInputBlur, onFocus: onFocusInput, autoComplete: "off", suffix: React.createElement("span", null), disabled: autoLogin }))),
        React.createElement("div", { className: classnames(styles.uInput, styles.uInputPwd) },
            React.createElement(Input.Password, { spellCheck: "false", "data-test-id": "pwd", className: styles.passwordInput, value: password, placeholder: getIn18Text('QINGSHURUMIMA'), onFocus: onFocusInput, onPressEnter: onLogin, autoComplete: "off", onChange: e => {
                    const { value } = e.target;
                    setPwd(value.replace(/[\u4e00-\u9fa5]+/g, ''));
                }, disabled: autoLogin }),
            capsLock ? (React.createElement("div", { className: styles.iCloseBtn },
                React.createElement(CapLockSVG, null))) : ('')),
        loginCodeVisible && (React.createElement(VefifyCode, { ref: verifyCodeInstanceRef, onChange: handleLoginVerifyCodeChanged, onVerifyCodeLoadError: handleLoginVerifyCodeLoadError })),
        isCorpMail && corpMailNeedImgVerifyCode && accountInfo && corpPreloginSid ? (React.createElement("div", { className: styles.uInput },
            React.createElement(CorpVerfiyCode, { accountName: accountInfo.account, accountDomain: accountInfo.domain, sid: corpPreloginSid, ref: corpVerifyImgCodeInstanceRef, onChange: handleVerifyCodeChanged, onVerifyCodeLoadError: handleVerifyCodeLoadError }))) : null,
        isWebFf ? (React.createElement("div", { "data-test-id": "bt-protocol-checked", className: styles.uCheckProtocol })) : (!isUnLockApp && (React.createElement("div", { className: styles.uCheckProtocol, onClick: () => setProtocolChecked(!protocolChecked) },
            React.createElement(SiriusRadio, { checked: protocolChecked, "data-test-id": "bt-protocol-checked" }, LoginProtocol())))),
        React.createElement("div", { className: styles.uSubmitBtn },
            React.createElement(Button, { "data-test-id": "bt-login-trigger", className: styles.uPrimaryBtn, type: "primary", onClick: onLogin, block: true, loading: loading }, loading ? ok : isUnLockApp ? getIn18Text('LOGIN_UNLOCK_BTN_TXT') : getIn18Text('DENGLU')))));
    const certValidateCom = (React.createElement("div", { className: styles.msgValidateWrap },
        React.createElement("div", { className: styles.uPhone }, getIn18Text('SHURUYOUBBXFWFCDYZM')),
        React.createElement("div", { className: classnames(styles.uInput, styles.uCode) },
            React.createElement(Input, { allowClear: true, "data-test-id": "cert-code-input", maxLength: isCorpMail ? 10 : 6, placeholder: `请输入${isCorpMail ? '' : 6}位验证码`, value: certCode, onFocus: onFocusInput, onChange: e => {
                    setCertCode(e.target.value);
                }, onKeyDown: e => keyDownHandler(e, 'cert'), ref: valRef }),
            React.createElement("div", { className: styles.uCodeText }, time < resendCodeWaitSpan ? (`${time}s后重试`) : (React.createElement("span", { className: "blue", onClick: onGetCertCode }, getIn18Text('HUOQUYANZHENGMA'))))),
        React.createElement("div", { style: { width: '100%' } },
            React.createElement(Button, { type: "primary", "data-test-id": "mobile-code-login-btn", className: styles.uPrimaryBtn, onClick: onLoginWithCertCode, block: true, loading: isLoginingWithCertCode }, getIn18Text('QUEDING')))));
    const renderContent = () => {
        if (isValidate) {
            if (validateWay === 'mobile') {
                return msgValidateDiv;
            }
            if (validateWay === 'mail') {
                return mailValidateDiv;
            }
            if (validateWay === 'cert') {
                return certValidateCom;
            }
        }
        return loginFormDiv;
    };
    const visibleBack = isValidate;
    const validateContent = (React.createElement("div", { className: styles.uLinkAccount, key: "account", hidden: inElectron },
        React.createElement(Checkbox, { onChange: e => {
                setNeedPersist(e.target.checked);
            }, checked: needPersist },
            React.createElement("span", { className: styles.validate }, getIn18Text('60TIANNEIMIAN')))));
    const registerContent = (React.createElement("div", { className: styles.uLinkAccount, key: "account" },
        React.createElement("span", null, getIn18Text('HAIMEIYOUTUANDUI')),
        React.createElement("span", { className: "blue", onClick: openPromptPage, "data-test-id": "login-register-link" }, getIn18Text('LIJIZHUCE'))));
    const pwdContent = (React.createElement("div", { className: styles.uLinkPwd, onClick: openForgetPwdUrl, key: "pwd", "data-test-id": "login-forget-pwd-link" }, getIn18Text('WANGJIMIMA')));
    let unLinkContent = (React.createElement(React.Fragment, null,
        !isCorpMail && !isAddAccount && !isUnLockApp && registerContent,
        React.createElement("div", { className: styles.hostChangeWrapper },
            pwdContent,
            !isCorpMail && !isAddAccount && !isUnLockApp && React.createElement("div", { className: styles.splitLine }),
            !isCorpMail && !isAddAccount && !isUnLockApp && React.createElement(HostChange, null))));
    if (isValidate && !isCorpMail) {
        unLinkContent = validateContent;
    }
    const switchTab = (tabName) => {
        storeApi.putSync('loginCurrentTab', tabName, { noneUserRelated: true });
        setCurrentTab(tabName);
    };
    const switchTabMail = () => {
        switchTab('mail');
    };
    const switchTabMobile = () => {
        switchTab('mobile');
    };
    const getLastLoginType = () => {
        const defaultType = 'QRCodeLogin';
        if (isWebFf || isUnLockApp)
            return 'PCLogin';
        if (!inWindow())
            return defaultType;
        let res = storeApi.getSync(LAST_LOGIN_TYPE_KEY, lastLoginTypeStoreConfig);
        if (res.suc && res.data) {
            return res.data;
        }
        return defaultType;
    };
    const setLastLoginType = (type) => {
        storeApi.putSync(LAST_LOGIN_TYPE_KEY, type, lastLoginTypeStoreConfig);
    };
    const [currentLoginType, setCurrentLoginType] = useState('PCLogin');
    const handleLoginTypeChange = (type) => {
        trackApi.track('pcLogin_switch_loginMode_loginPage', { mode: type });
        setCurrentLoginType(type);
        if (!isUnLockApp) {
            setLastLoginType(type);
        }
    };
    const supportQRCodeLogin = isWebFf ? false : inWindow() ? (window.featureSupportInfo.supportNativeProxy ? true : false) : false;
    const showQRCodeLogin = process.env.BUILD_ISEDM || hideQrCodeLogin ? false : supportQRCodeLogin;
    const isQRCodeMode = showQRCodeLogin ? currentLoginType === 'QRCodeLogin' : false;
    const needBindMobile = useCallback((mobile) => {
        if (mobile || !process.env.BUILD_ISEDM || !(type === 'common' || !type) || isQRCodeMode || isCorpMail) {
            return false;
        }
        const { data, suc } = storeApi.getSync(StorageKey.LoginSkipBindMobile, { noneUserRelated: true });
        if (suc && data) {
            const bindMobileMap = JSON.parse(data || '{}');
            if (email && bindMobileMap[email]) {
                return false;
            }
        }
        return true;
    }, [type, isQRCodeMode, email, isCorpMail]);
    return (React.createElement("div", { className: classnames(styles.loginContainer, [type === 'addAccount' && styles.addAccountLoginWrap]), style: noBorder ? { border: 'none' } : {}, hidden: registerInfo.visible },
        shouldShowBack && (React.createElement("div", { className: styles.backWrap, onClick: goBack, style: Object.assign({}, backStyle) },
            React.createElement("div", { className: styles.backIcon + ' dark-invert' },
                React.createElement("i", null)),
            React.createElement("span", { key: "back", className: styles.back }, getIn18Text('FANHUI')))),
        showQRCodeLogin && React.createElement(QRCodeSwitch, { useType: isUnLockApp ? 'unLockApp' : 'common', type: currentLoginType, onTypeChange: handleLoginTypeChange }),
        isQRCodeMode && React.createElement(QrcodeValidate, { type: type, key: "mailQrCodeLogin", onLogin: onQrCodeLogin, onUnLockAppSuccess: onUnLockAppSuccess }),
        React.createElement("div", { key: "mailPwdLogin", className: styles.loginWrap, style: { display: isQRCodeMode ? 'none' : 'block' } },
            React.createElement("div", { className: styles.backWrap, hidden: !visibleBack, onClick: goBack, style: Object.assign({}, backStyle) },
                React.createElement("div", { className: styles.backIcon + ' dark-invert' },
                    React.createElement("i", null)),
                React.createElement("span", { key: "back", className: styles.back }, getIn18Text('FANHUI'))),
            React.createElement("div", { className: styles.title }, mainTitle),
            React.createElement("div", { className: styles.loginFormWrap },
                React.createElement("div", { className: styles.loginTabs, hidden: isAddAccount || isValidate || isUnLockApp },
                    React.createElement("div", { "data-test-id": "sw-mail-login", className: classnames(styles.tab, {
                            [styles.active]: currentTab === 'mail',
                        }), onClick: switchTabMail },
                        React.createElement("span", { className: styles.tabTxt }, getIn18Text('YOUXIANG')),
                        React.createElement("b", { className: styles.tabLine })),
                    React.createElement("div", { "data-test-id": "sw-mobile-login", hidden: isWebFf, className: classnames(styles.tab, {
                            [styles.active]: currentTab === 'mobile',
                        }), onClick: switchTabMobile },
                        React.createElement("span", { className: styles.tabTxt }, getIn18Text('SHOUJIHAO')),
                        React.createElement("b", { className: styles.tabLine }))),
                React.createElement("div", { className: styles.loginContent, style: { height: isUnLockApp ? '244px' : '304px' } },
                    React.createElement("div", { className: styles.mailWrap, hidden: currentTab !== 'mail' },
                        renderContent(),
                        React.createElement("div", { hidden: isWebFf || validateWay === 'cert', className: styles.uLink }, unLinkContent),
                        React.createElement("div", { className: styles.uWarning, hidden: !warning },
                            React.createElement(ErrorIcon, { width: 14, height: 14, className: styles.uWarningIcon }),
                            React.createElement("span", { className: styles.uWarningText }, warning))),
                    React.createElement("div", { className: styles.mobileWrap, hidden: currentTab !== 'mobile' || type === 'addAccount' },
                        React.createElement(MobileValidate, { from: "login", onShowDeviceRegister: () => {
                                setDeviceReportModalVisible(true);
                            }, type: type, toRegister: isAddAccountPage ? undefined : openPromptPage }))))),
        systemApi.getIsAddAccountPage() || isUnLockApp ? null : (React.createElement("div", { className: styles.langMenusWrapper, "data-test-id": "bt-language-menus" },
            React.createElement(LangMenus, { iconColor: "#7d8085", iconClassName: styles.langMenuIcon }))),
        process.env.BUILD_ISEDM || systemApi.getIsAddAccountPage() || isUnLockApp ? null : (React.createElement("div", { className: styles.feedbackWrapper, onClick: () => {
                setShowFeedbackModal(!showFeedbackModal);
            } }, getIn18Text('WENTIFANKUI'))),
        showFeedbackModal ? (React.createElement(FeedbackModal, { feedbackType: "login", visible: showFeedbackModal, cancel: () => {
                setShowFeedbackModal(false);
            } })) : null,
        React.createElement(MobileBindModal, { visible: visibleBindMobileModal, setVisible: v => {
                setVisibleBindMobileModal(v);
            }, onSuccess: () => {
                routerUrl();
            } }),
        mobileUnBlockVisible && (React.createElement(SelfUnBlockMobildModal, { mobile: unBlockMobile, visible: mobileUnBlockVisible, onCancel: () => {
                setMobileUnBlockVisible(false);
            }, onClose: () => {
                setMobileUnBlockVisible(false);
            }, onFail: errMsg => {
                Modal.error({
                    content: errMsg,
                    maskClosable: false,
                    okText: getIn18Text('ZHIDAOLE'),
                    hideCancel: true,
                });
            }, onSuccess: () => {
                setMobileUnBlockVisible(false);
                setTimeout(() => {
                    Modal.success({
                        content: getIn18Text('SPAM_UNLOCK_SUC'),
                        maskClosable: false,
                        okText: getIn18Text('ZHIDAOLE'),
                        hideCancel: true,
                    });
                }, 0);
            } })),
        emailUnBlockVisible && (React.createElement(EmailUnBlockModal, { visible: emailUnBlockVisible, onCancel: () => {
                setEmailUnBlockVisible(false);
            }, onClose: () => {
                setEmailUnBlockVisible(false);
            } })),
        deviceReportModalVisible ? (React.createElement(DeviceReportLoginModal, { onClose: () => {
                setTimeout(() => {
                    setDeviceReportModalVisible(false);
                    setOutDeviceReportVisible && setOutDeviceReportVisible(false);
                }, 300);
            } })) : null));
};
export default Login;
